<template>
    <div>
        <compWrapper title="测算结果" theme="primary">
            <compFormEdit
                class="margin-15 clearfix"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
        </compWrapper>
        <compWrapper title="测算附件" theme="info">
            <vButton
                class="margin-top-15 margin-left-15"
                theme="primary"
                @click="adddocument"
                >添加附件</vButton
            >
            <span class="margin-left-10 color-error"
                >最多传5个附件，超过请压缩后再上传</span
            >

            <vTable
                class="margin-15"
                :columns="doccolumns"
                :data="docList"
                size="small"
                ref="tablequery"
                border
            ></vTable>
        </compWrapper>
        <!-- 全局弹框 -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="closemodalprops"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
            ></component>
        </compModal>
        <div class="text-right margin-right-15">
            <Button class="margin-right-15" type="primary" @click="submit(2)"
                >确认</Button
            >
            <Button @click="cancel">取消</Button>
        </div>
        <!-- 添加全局的liading -->
        <vLoading size="large" transfer fix :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpEditCalculationReleaseByManagement,
    HttpGetAccountAgreementList,
    HttPpriceAdjustmentCalculation,
} from "@/service/products/calculationRelease";
import { HttpDelAttachNew } from "@/service/purchase/purchase";
export default {
    props: [],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
        return {
            id: this.$route.query.id,
            type: this.$route.params.type,
            formData: {},
            docList: [],
            accountAgreementList: [],
            loading: false,
            modalProps: {
                show: false,
                title: "",
                component: null,
            },
            fieldMapping: {
                DA: "daPointScale",
                Freight: "freightPointScale",
                COOP: "coopPointScale",
                Termsdiscount: "termsdiscountPointScale",
            },
        };
    },
    created() {
        this.update();
    },
    computed: {
        ...mapState("boss", ["accounts"]),
        getBase() {
            return [
                {
                    label: "店铺",
                    tag: "vSelect",
                    key: "accountFlag",
                    options: this.accountAgreementList.map(function (item) {
                        return {
                            value: item.id,
                            label:
                                item.accountFlag +
                                "(" +
                                item.vendorCode +
                                ":" +
                                item.term +
                                ")",
                        };
                    }),
                    on: {
                        "on-change": (val) => {
                            this.changeChannel(val);
                        },
                    },
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "销售价",
                    key: "sellingPrice",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "供货价",
                    key: "supplyPrice",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "广告投入",
                    key: "advertisingInvestment",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "退货占比",
                    key: "returnProportion",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "客户最终回款",
                    key: "paymentCollection",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "运费预估",
                    key: "freightEstimation",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "amazon利润占比",
                    key: "amazonProfit",
                    tag: "vInputNumber",
                    span: 12,
                },
                {
                    label: "客户利润占比",
                    key: "customerProfit",
                    tag: "vInputNumber",
                    span: 12,
                },
            ];
        },
        doccolumns() {
            // let array =
            let _this = this;
            return [
                {
                    title: "附件名称",
                    key: "attachTitle",
                    render: (h, { row }) => {
                        return (
                            <a href={row.attachUrl} target="_blank">
                                {row.attachTitle}
                            </a>
                        );
                    },
                },
                {
                    title: "操作时间",
                    key: "attachOpAt",
                },
                {
                    title: "操作人",
                    key: "createdName",
                },
                {
                    title: "操作",
                    // width: 140,
                    render(h, { row, index }) {
                        let delButton = "";
                        if (_this.type !== "query") {
                            delButton = h(
                                "vButton",
                                {
                                    props: {
                                        theme: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                    style: {
                                        "margin-right": "15px",
                                    },
                                },
                                "删除"
                            );
                        }
                        return h("div", [
                            delButton,
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.downfile(row.attachUrl);
                                        },
                                    },
                                },
                                "下载"
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    methods: {
        closemodalprops() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        update() {
            HttpGetAccountAgreementList({
                contextId: global.SYSID,
                releaseId: this.id,
            }).then((res) => {
                this.accountAgreementList = res.data;
                // 遍历数组中的每个对象
                this.accountAgreementList.forEach((item) => {
                    const result = [];
                    if (this.formData)
                        // 对每个对象处理字段
                        Object.entries(this.fieldMapping).forEach(
                            ([displayName, fieldName]) => {
                                if (item.hasOwnProperty(fieldName)) {
                                    const value = item[fieldName];
                                    result.push(
                                        `${displayName}:${
                                            value != null ? value + "%" : 0
                                        }`
                                    );
                                }
                            }
                        );
                    // 将格式化字符串赋给当前对象的 term 属性
                    item.term = result.join("; ");
                });
            });
        },
        adddocument() {
            this.modalProps = {
                show: true,
                title: "添加附件",
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.id || 0,
                    model: "changeLabel",
                    type: "other",
                },
                showFooter: false,
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: true,
                beforeUpload: (fileList) => {
                    if (fileList.length > 5) {
                        this.$VMessage.error("附件数量过多，请打包后上传");
                        return false;
                    } else {
                        return true;
                    }
                },
                on: {
                    "on-success": (res) => {
                        res.items.map((item) => {
                            this.docList.push(item);
                        });
                        window.console.log("this.docList", this.docList);
                        this.modalProps = {};
                    },
                    "on-cancel": () => {
                        this.modalProps = {};
                    },
                },
            };
        },
        downfile(url) {
            this.handleWebfs(url, {}, "download");
        },
        remove(index, useId) {
            HttpDelAttachNew({
                id: useId ? index : this.docList[index].attachId,
            }).then(
                (res) => {
                    if (!useId) {
                        this.docList.splice(index, 1);
                        this.$VMessage.success(res.message);
                    }
                },
                (err) => {
                    if (!useId) {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                }
            );
        },
        changeChannel(val) {
            const value = this.accountAgreementList.find(
                (item) => item.id === val
            );
            this.formData.channelId = value.accountId;
            this.formData.channelFlag = value.accountFlag;
            this.formData.vendorCode = value.vendorCode;
            this.formData.term = value.term;
        },
        async submit(status) {
            let bool3 = await this.$refs.editform.validate();
            if (!bool3) {
                return;
            }
            if (this.docList.length === 0) {
                this.$VMessage.error("请上传测算附件");
                return;
            } else {
                this.formData.attachment = JSON.stringify(this.docList);
            }
            if (this.type == "edit") {
                this.formData.isPush = 0;
                this.formData.id = this.id;
                this.formData.status = status;
                this.loading = true;
                HttpEditCalculationReleaseByManagement({
                    ...this.formData,
                }).then(
                    (res) => {
                        this.loading = false;
                        this.$VMessage.success(res.message);
                        this.cancel();
                    },
                    (err) => {
                        this.loading = false;
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            } else {
                this.formData.id = this.id;
                this.formData.adjustStatus = status;
                this.formData.status = status;
                this.loading = true;
                HttPpriceAdjustmentCalculation({
                    ...this.formData,
                }).then(
                    (res) => {
                        this.loading = false;
                        this.$VMessage.success(res.message);
                        this.cancel();
                    },
                    (err) => {
                        this.loading = false;
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }
        },
        cancel() {
            this.$router.push({
                name: "calculationReleaseAdminList",
            });
        },
    },
};
</script>
